import * as React from "react";
import ReactDOM from "react-dom/client";
import "@pulse-ui/styling/index.scss";
import "@mantine/core/styles.css";
import "@mantine/dates/styles.css";
import "@mantine/notifications/styles.css";

// Component Imports
import App from "./App";

// Package Imports
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { SnackbarProvider } from 'notistack';

// Theme Imports
import { ThemeProvider, CssBaseline } from "@mui/material";
import { theme } from "./theme";
import { MantineProvider } from "@mantine/core";
import { Notifications } from "@mantine/notifications";
import { pulseTheme } from "@pulse-ui/shared-components";

import "ag-grid-enterprise";
import { LicenseManager } from "ag-grid-enterprise";
LicenseManager.setLicenseKey(
  "Using_this_{AG_Grid}_Enterprise_key_{AG-067783}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Pulse}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{Pulse}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{Pulse}_need_to_be_licensed___{Pulse}_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{27_September_2025}____[v3]_[01]_MTc1ODkyNzYwMDAwMA==58f2cf251f207bfeb175c2fecc87f6fb"
);

// Redux Provider
import { Provider } from "react-redux";
import store, { persistor } from "./src/store";
import { PersistGate } from "redux-persist/integration/react";

// Widget API client
import { configureApiClient } from "@pulse-ui/api-client";
import { clearAuth, setAuthError } from "./src/features/auth/authSlice";

configureApiClient({
  jwtKey: "pulsejwt",
  tradeEngineUrl: "https://trade-engine.cs-dev.tokyo.pulseprime.systems",
  onSessionExpiry: () => {
    store.dispatch(setAuthError("Session expired. Please log in again."));
    store.dispatch(clearAuth());
    window.location.href = "/";
  },
});

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <DndProvider backend={HTML5Backend}>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <MantineProvider theme={pulseTheme} defaultColorScheme="dark">
          <Notifications position="bottom-right" autoClose={4000} />
          <CssBaseline>
            <ThemeProvider theme={theme}>
              <SnackbarProvider
                maxSnack={3}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'right',
                }}
                autoHideDuration={5000}
              >
                <App />
              </SnackbarProvider>
            </ThemeProvider>
          </CssBaseline>
        </MantineProvider>
      </PersistGate>
    </Provider>
  </DndProvider>
);
